import { Theme, useTheme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { PaymentMethod } from '../../store/config/types';
import styles from '../../styles/_variables.module.scss';
import { CustomSwitch } from '../CustomSwitch';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      padding: '0.625rem 0.8125rem',
      boxShadow: styles.boxShadowSmall,
      boxSizing: 'border-box',
      flexBasis: '49%',
      marginTop: '1.1875rem',
      [theme.breakpoints.down('md')]: {
        flexBasis: '100%',
      },
    },
    details: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    image: {
      padding: '0.5rem 1rem',
      width: '30%',
      border: `1px solid ${styles.greyTableHead}`,
    },
    issuerNameText: {
      color: styles.darkBlue,
      fontSize: '0.9375rem',
      margin: 0,
    },
    maxInstallmentsText: {
      color: styles.slateBlue,
      fontSize: '0.875rem',
      margin: 0,
    },
  }),
);

interface PaymentMethodCardProps {
  paymentMethod: PaymentMethod;
  paymentMethodsIds: number[];
  setPaymentMethodsIds(value: number[]): void;
}

function PaymentMethodCard({
  paymentMethod,
  paymentMethodsIds,
  setPaymentMethodsIds,
}: PaymentMethodCardProps) {
  const classes = useStyles(useTheme());
  const maxInstallments = paymentMethod.values.sort((a: number, b: number) => b - a)[0];

  const handleTogglePaymentMethod = (paymentMethod: PaymentMethod) => {
    const existingIndex = paymentMethodsIds.findIndex((id) => id === Number(paymentMethod.id));

    if (existingIndex !== -1) {
      const newIds = [...paymentMethodsIds];
      newIds.splice(existingIndex, 1);
      setPaymentMethodsIds(newIds);
    } else {
      setPaymentMethodsIds([...paymentMethodsIds, Number(paymentMethod.id)]);
    }
  };

  return (
    <div className={classes.card}>
      <div className={classes.details}>
        <img className={classes.image} src={paymentMethod.issuerImageUrl} alt={paymentMethod.issuerName} />
        <div>
          <p className={classes.issuerNameText}>{paymentMethod.issuerName}</p>
          <p className={classes.maxInstallmentsText}>{`Hasta en ${maxInstallments} ${
            maxInstallments > 1 ? 'cuotas' : 'cuota'
          }`}</p>
        </div>
        <CustomSwitch
          onClick={() => handleTogglePaymentMethod(paymentMethod)}
          checked={paymentMethodsIds.includes(Number(paymentMethod.id))}
        />
      </div>
    </div>
  );
}

export default PaymentMethodCard;
